import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class CandidateService {
  candidates: any;
  constructor(private http: HttpClient) { }

  getCandidates(
    pageNumber: string = '1',
    query: string = '',
    pageSize: string = '10'
  ): Observable<any> {
    return this.http.get(
      `${environment.apiConfig.uri}/admin/Candidates?pageNumber=` +
      pageNumber +
      '&query=' +
      query +
      '&pagesize=' +
      pageSize
    );
  }

  getClients(
  pageNumber: string = '1',
  query: string = '',
  pageSize: string = '10'
): Observable<any> {
  return this.http.get(
    `${environment.apiConfig.uri}/admin/AdminClientContact/GetClientDeatils?pageNumber=` +
    pageNumber +
    '&query=' +
    query +
    '&pagesize=' +
    pageSize
  );
}
clientStatus(id:any): Observable<any> {
  return this.http.get(`${environment.apiConfig.uri}/admin/AdminClientContact/GetClient?clientId=${id}`);
}
}
